module.exports = __webpack_public_path__ + "media/categories/1052-ac4fe12d.svg";